import { memo, useCallback } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteProduct } from 'modules/inventory/product/hooks/useDeleteProduct';
import { EditRowActions } from '@dfl/mui-admin-layout';
import { useNavigate } from 'react-router';
import { PRODUCT_ERRORS } from '../../constants/errors';
import DeleteRowAction from 'components/Actions/DeleteAction/DeleteRowAction';
import { IProduct } from '../../interfaces/IProduct';
import { ProductCloneButton } from '../ProductDetailActions';
import { disabledCloneProduct } from 'utils/flags-utils';

type UserStatusProps = {
  rowId: string;
  record: IProduct;
};

const ProductRowActions = ({ rowId, record }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const navigate = useNavigate();
  const { mutate, isPending, error } = useDeleteProduct(rowId, onClose);

  const goTo = useCallback(() => {
    navigate(`/inventory/products/${rowId}/general?edit=true`);
  }, [rowId, navigate]);

  return (
    <>
      <Stack direction='row' spacing={1} justifyContent={'center'}>
        <EditRowActions onClick={goTo} />
        {!disabledCloneProduct && <ProductCloneButton iconButton record={record} />}
        <DeleteRowAction
          open={isOpen}
          onOpen={onOpen}
          data={record}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onConfirm={mutate}
          errors={PRODUCT_ERRORS}
          confirmationValue={record?.name || record?.code}
        />
      </Stack>
    </>
  );
};

export default memo(ProductRowActions);
